import { ModelBase } from "../shared/model.base";

export class Operator extends ModelBase {
    id: number;
    name: "";
    active: boolean;
    msisdn_regex: "";
    msisdn_length: number;
    start_window: "";
    end_window: "";
    id_country: number;
    country_name: "";
    protocolId: number;
    protocol;

    constructor() {
        super();
    }
}
